import { useEffect, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '../store';
import { getAgencyConfig } from '../services/agencyConfig';

/**
 * Whether this agency sends its OASIS assessments to SHP each night.
 *
 * `false` until the config resolves and on failure: the only cost is a column
 * that appears a beat late, and an agency that never opted in sees nothing.
 */
export function useShpOasisSubmissionEnabled(): boolean {
  const agencyId = useStore(useShallow(s => s.user?.agency?.id));
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!agencyId) {
      setEnabled(false);
      return;
    }
    let cancelled = false;

    const load = async () => {
      try {
        const cfg = await getAgencyConfig();
        if (!cancelled) {
          setEnabled(Boolean(cfg.shp_oasis_submission_enabled));
        }
      } catch {
        if (!cancelled) setEnabled(false);
      }
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [agencyId]);

  return enabled;
}
